/**
 * Duplicates marquee strips for seamless CSS scroll loops.
 */
function initMarqueeHeroOverlays() {
  document.querySelectorAll('[data-marquee-hero-root]').forEach((root) => {
    if (root.dataset.marqueeHeroReady === 'true') return;
    root.dataset.marqueeHeroReady = 'true';

    root.querySelectorAll('.marquee-hero-overlay__strip').forEach((strip) => {
      const clone = strip.cloneNode(true);
      strip.parentElement?.appendChild(clone);
    });
  });
}

document.addEventListener('DOMContentLoaded', initMarqueeHeroOverlays);
document.addEventListener('shopify:section:load', initMarqueeHeroOverlays);
